import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=3526d8db&"
import script from "./QuillEditor.vue?vue&type=script&lang=js&"
export * from "./QuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VContainer,VTooltip})
